import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz16 = () => {
    return (
        <div class='container'>
               <NavLink to='/category/Puzzels/Puzzel17'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel15'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article
    class="content post-142633 post type-post status-publish format-standard hentry category-mathematical category-puzzles"
    id="post-142633">
    <h1 class="title">100 Doors</h1>
   

    <div class="text">
        <p>There are 100 doors in a row, all doors are initially closed. A person walks through all doors multiple times
            and toggle (if open then close, if close then open) them in following way:&nbsp;</p>
        <p>In first walk, the person toggles every door&nbsp;</p>
        <p>In second walk, the person toggles every second door, i.e., 2<sup>nd</sup>, 4<sup>th</sup>, 6<sup>th</sup>,
            8<sup>th</sup>, …&nbsp;</p>
        <p>In third walk, the person toggles every third door, i.e. 3<sup>rd</sup>, 6<sup>th</sup>, 9<sup>th</sup>,
            …&nbsp;</p>
        <p>………&nbsp;<br/>
            ……….&nbsp;</p><br/>
        
        
        <p>In 100<sup>th</sup> walk, the person toggles 100<sup>th</sup> door.&nbsp;</p>
        <p><strong>Which doors are open in the end?</strong>&nbsp;</p>
        <div class="containers">
        <p><strong>Solution:</strong>&nbsp;<br/>
            A door is toggled in i<sup>th</sup> walk if i divides door number. For
            example the door number 45 is toggled in 1<sup>st</sup>, 3<sup>rd</sup>, 5<sup>th</sup>, 9<sup>th</sup>
            ,15<sup>th</sup> and 45<sup>th</sup> walk.<br/>
            The door is switched back to an initial stage for every pair
            of divisors. For example, 45 is toggled 6 times for 3 pairs (5, 9), (15, 3) and (1, 45).&nbsp;<br/>
            It looks
            like all doors would become closes at the end. But there are door numbers which would become open, for
            example, 16, the pair (4, 4) means only one walk. Similarly all other perfect squares like 4, 9, ….&nbsp;
        </p>
        <p>So the answer is 1, 4, 9, 16, 25, 36, 49, 64, 81 and 100.&nbsp;</p>
       </div>
    </div>
</article>
        </div>
    )
}

export default Puz16
